/**
 * Instrument helpers shared by Market Watch, the order ticket and strategies.
 * Kept out of component files so React Fast Refresh stays happy.
 */

export const SEGMENT_OPTIONS = [
  { value: 'nse_cm', label: 'NSE Equity' },
  { value: 'nse_fo', label: 'NSE F&O' },
  { value: 'bse_cm', label: 'BSE Equity' },
  { value: 'bse_fo', label: 'BSE F&O' },
  { value: 'cde_fo', label: 'Currency' },
  { value: 'mcx_fo', label: 'Commodity' },
] as const;

/** F&O segments end in `_fo`; only they carry open interest and lot sizes > 1. */
export function isDerivativeSegment(segment: string): boolean {
  return segment.endsWith('_fo');
}
